import { render, staticRenderFns } from "./BudgetMonitoringPoDetail.vue?vue&type=template&id=38619ad4&scoped=true"
import script from "./BudgetMonitoringPoDetail.vue?vue&type=script&lang=js"
export * from "./BudgetMonitoringPoDetail.vue?vue&type=script&lang=js"
import style0 from "./BudgetMonitoringPoDetail.vue?vue&type=style&index=0&id=38619ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38619ad4",
  null
  
)

export default component.exports